class HeaderDetailsDisclosure extends DetailsDisclosure {
    constructor() {
        super();
        this._boundClickListener = this.clickListener.bind(this); // Bind click listener
    }

    connectedCallback() {
        this._summaryLink = this.querySelector("summary > a");
        if (!this.mainDetailsToggle.hasAttribute("open")) this._disableSummaryLink();
        this.mainDetailsToggle.addEventListener("click", this._boundClickListener); // Use click event
    }

    disconnectedCallback() {
        this.disableListeners();
    }

    open() {
        this.mainDetailsToggle.setAttribute("open", "");
        this.querySelector("summary").setAttribute("aria-expanded", !0);
        if (this.content.getBoundingClientRect().x + this.content.offsetWidth > window.innerWidth - 30) {
            this.content.classList.add("is-left-aligned");
        }
        if (this.hasAttribute("adjust-mega-menu-height")) this._setContentHeight(36);
    }

    close() {
        this.mainDetailsToggle.removeAttribute("open");
        this.mainDetailsToggle.querySelector("summary").setAttribute("aria-expanded", !1);
        this.content.classList.remove("is-left-aligned");
        if (this.hasAttribute("adjust-mega-menu-height")) this._removeContentHeight();
    }

    onToggle() {
        if (!this.animations) this.animations = this.content.getAnimations();
        if (!this.contentAnimations) {
            this.contentAnimations = Array.from(this.querySelectorAll(".has-animation")).reduce(
                (animations, element) => {
                    const animation = element.getAnimations();
                    return [...animations, ...animation];
                },
                []
            );
        }
        if (this.mainDetailsToggle.hasAttribute("open")) {
            setTimeout(() => {
                this._enableSummaryLink();
            }, 50);
            this.animations.forEach((animation) => animation.play());
            this.contentAnimations.forEach((animation) => animation.play());
            document.body.setAttribute("header-menu-open", "");
            if (this.classList.contains("mega")) {
                document.body.setAttribute("header-mega-menu-open", "");
            }
        } else {
            this._disableSummaryLink();
            this.animations.forEach((animation) => animation.cancel());
            this.contentAnimations.forEach((animation) => animation.cancel());
            document.body.removeAttribute("header-menu-open", "");
            if (this.classList.contains("mega")) {
                document.body.removeAttribute("header-mega-menu-open", "");
            }
        }
    }

    clickListener() {
        if (!document.querySelector("body").hasAttribute("header-details-disclosure-edit")) {
            if (this.mainDetailsToggle.hasAttribute("open")) {
                this.close(); // Close if open
            } else {
                this.open(); // Open if closed
            }
        }
    }

    disableListeners() {
        this.mainDetailsToggle.removeEventListener("click", this._boundClickListener); // Remove click listener
    }

    _setContentHeight(padding = 0) {
        const headerSection = document.querySelector(".js-header");
        const headerBottomBoundary =
            headerSection && headerSection.getBoundingClientRect().bottom > 0
                ? headerSection.getBoundingClientRect().bottom
                : 0;
        const combinedPanelCutoff = Math.round(headerBottomBoundary + padding);
        if (this.content.offsetHeight > window.innerHeight - combinedPanelCutoff) {
            this.content.style.setProperty("--header-elements-height", `${combinedPanelCutoff}px`);
            this.content.classList.add("has-height-control");
        }
    }

    _removeContentHeight() {
        this.content.classList.remove("has-height-control");
    }

    _summaryLinkListener(e) {
        e.preventDefault();
    }

    _enableSummaryLink() {
        if (this._summaryLink) this._summaryLink.removeEventListener("click", this._summaryLinkListener);
    }

    _disableSummaryLink() {
        if (this._summaryLink) this._summaryLink.addEventListener("click", this._summaryLinkListener);
    }
}
customElements.define("header-details-disclosure", HeaderDetailsDisclosure);